var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "rgb(80, 76, 92)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1213 1796 c-93 -30 -169 -91 -197 -158 -21 -50 -20 -94 4 -146 20 -44 20 -44 -2 -129 -20 -82 -20 -87 -3 -99 15 -11 30 -7 106 31 48 25 94 43 101 40 7 -3 44 -9 83 -14 228 -32 445 90 445 251 0 37 -47 124 -83 151 -67 51 -179 93 -213 80 -8 -3 -14 -16 -14 -29 0 -18 7 -25 28 -30 155 -34 242 -118 213 -207 -39 -116 -238 -185 -415 -143 -59 14 -61 14 -119 -16 -32 -16 -61 -28 -63 -26 -2 2 3 28 11 58 13 51 13 55 -8 84 -65 91 11 204 164 246 56 15 64 20 64 41 0 20 -6 24 -30 26 -16 1 -49 -4 -72 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313 1643 c-18 -7 -16 -48 2 -63 14 -12 14 -15 0 -30 -34 -38 -5 -75 38 -47 20 13 25 13 44 0 43 -28 72 9 38 47 -14 15 -14 18 0 30 20 17 19 56 -1 64 -9 4 -24 0 -34 -9 -21 -19 -34 -19 -50 0 -13 16 -17 17 -37 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 1313 c-37 -14 -50 -36 -50 -87 -1 -105 52 -932 61 -953 l9 -23 550 0 c603 0 594 -1 624 58 8 16 26 73 40 128 22 87 23 101 10 114 -27 27 -47 -1 -76 -106 -18 -67 -33 -104 -48 -116 -21 -17 -57 -18 -531 -18 -280 0 -509 3 -509 7 0 6 100 374 136 501 l15 52 525 0 c288 0 524 -3 524 -6 0 -3 -9 -42 -21 -87 -19 -75 -19 -82 -4 -93 36 -27 46 -10 85 144 16 65 18 87 9 98 -10 12 -103 14 -574 14 -310 0 -570 -3 -578 -6 -9 -3 -38 -87 -78 -232 -35 -125 -65 -218 -66 -207 -4 30 -43 696 -43 728 l0 27 134 0 133 0 47 -60 47 -60 350 0 349 0 0 -54 c0 -61 19 -88 45 -66 12 10 15 31 13 94 l-3 81 -362 3 -362 2 -38 50 c-56 72 -79 80 -225 79 -67 0 -130 -3 -138 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820 675 c-18 -22 -5 -43 32 -50 61 -12 108 21 76 53 -17 17 -93 15 -108 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262 678 c-32 -32 14 -65 76 -53 29 5 33 10 30 33 -3 24 -7 27 -48 30 -26 2 -50 -2 -58 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 513 c-22 -11 -36 -27 -38 -41 -4 -27 23 -40 49 -24 24 16 64 15 89 0 16 -10 23 -10 37 5 17 16 16 18 -8 42 -33 34 -84 41 -129 18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/NotFound.8796f6577962a4975705c39ab4409f51.svg";
export { ForwardRef as ReactComponent };